// extracted by mini-css-extract-plugin
module.exports = {"page":"CategoryPage_page__sVzFK"};